import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const EditInternshipSessions = () => {
  return (
    <Edit
      title="Редактиране на сесия"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditInternshipSessions;
